module.exports = __webpack_public_path__ + "static/img/bg.a2d7623a.jpg";